var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgChatIcon = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "24px",
  height: "24px",
  viewBox: "0 0 24 24",
  fill: "#7D7D7D",
  xmlns: "http://www.w3.org/2000/svg",
  xmlnsXlink: "http://www.w3.org/1999/xlink",
  ref: ref,
  "aria-labelledby": titleId
}, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, "Chat icon") : title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
  id: "Home",
  stroke: "none",
  strokeWidth: 1,
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "APP-KIT",
  transform: "translate(-220.000000, -1412.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Chat-icon",
  transform: "translate(220.000000, 1412.000000)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M24,0 L24,24 L0,24 L0,0 L24,0 Z",
  id: "Vector",
  opacity: 0
}), /*#__PURE__*/React.createElement("g", {
  id: "Group",
  transform: "translate(2.833333, 2.833333)",
  fillRule: "nonzero"
}, /*#__PURE__*/React.createElement("path", {
  d: "M16.1469285,14.5467615 L16.0818145,14.3365246 C16.0632294,14.2692443 16.0788784,14.1971272 16.1236777,14.143601 C18.3575344,11.564551 18.8232911,7.97249578 17.3113791,4.93836018 C15.8938879,2.09253138 12.9789786,0.218066005 9.70808729,0.0135060785 L9.41460425,-6.03961325e-15 L9.09624295,-6.03961325e-15 C5.45531061,-6.03961325e-15 2.15864335,2.0671108 0.724693062,5.26117074 C-0.703189734,8.45843318 0.017219371,12.1661332 2.54838022,14.6713796 C5.0177635,17.1026639 8.73128131,17.9398556 12.0621718,16.8403118 L12.3348756,16.7457258 C12.4011839,16.7221111 12.4743468,16.7273068 12.5366524,16.760055 L12.8502389,16.9104762 C13.6505622,17.3034828 14.8071019,17.7262415 16.117752,18.1440326 C16.9220101,18.398466 17.6631929,17.5560836 17.2260824,16.8059171 C16.7513405,15.989248 16.3642311,15.2022249 16.1469285,14.5467615 Z M9.09624295,1.19 L9.39449505,1.18966009 C12.3446603,1.28942373 14.9867864,2.9404558 16.2462439,5.46900789 C17.5432572,8.07188052 17.144464,11.1474931 15.2176427,13.3721742 C14.9153906,13.733172 14.8120869,14.2092392 14.9352662,14.6551631 L15.021135,14.932114 C15.1774818,15.4012544 15.3988009,15.9071657 15.6672706,16.4347384 L15.8626741,16.809278 L15.2776275,16.6090138 C14.6152135,16.3761064 14.027704,16.1467413 13.5614337,15.9311304 L13.0701558,15.6965862 C12.775811,15.5414543 12.4184694,15.499299 12.0795317,15.5817143 L11.9216223,15.6296868 C8.95032858,16.708542 5.58887872,15.9949858 3.38438322,13.824505 C1.20422285,11.6666626 0.586690752,8.48843547 1.81078426,5.74748808 C3.04951484,2.98827406 5.9174362,1.19 9.09624295,1.19 Z",
  id: "Fill-1",
  transform: "translate(9.095169, 9.095178) scale(-1, 1) translate(-9.095169, -9.095178) "
}), /*#__PURE__*/React.createElement("polygon", {
  id: "Stroke-15",
  points: "13.1496334 6.63 13.1496334 7.82 4.93 7.82 4.93 6.63"
}), /*#__PURE__*/React.createElement("polygon", {
  id: "Stroke-19",
  points: "11.4496334 9.71536093 11.4496334 10.9053609 4.93 10.9053609 4.93 9.71536093"
})))))));
const ForwardRef = /*#__PURE__*/forwardRef(SvgChatIcon);
export default ForwardRef;